module.exports = __webpack_public_path__ + "img/billet_5.a0b794c7.jpg";